import { Grid } from "@material-ui/core";
import React from "react";

import RegisterCard from "./RegisterCard";

/**
 * RegisterPageコンポーネント.
 *
 * @return {object} コンポーネント
 */
function RegisterPage() {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <RegisterCard />
      </Grid>
    </Grid>
  );
}

export default RegisterPage;
